/**
 * Celebration overlay (BRIEF §23): staged reveal —
 * "round-up detected" → "Buying NVDA…" → 🎉 invested.
 */
import { useEffect, useState } from "react";
import { formatPence, formatPenceShort } from "../lib/money";
import type { CelebrationPayload } from "../lib/store";

export function Celebration({
  payload,
  onDone,
}: {
  payload: CelebrationPayload;
  onDone: () => void;
}) {
  const [stage, setStage] = useState<0 | 1 | 2>(0);

  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 1100);
    const t2 = setTimeout(() => setStage(2), 2300);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  const roundupLabel =
    payload.count > 1
      ? `${payload.count} round-ups totalling ${formatPenceShort(payload.roundupPence, payload.currency)}`
      : `your ${formatPenceShort(payload.roundupPence, payload.currency)} round-up`;

  return (
    <div className="celebration-backdrop" onClick={stage === 2 ? onDone : undefined}>
      <div className="celebration">
        {stage === 0 && (
          <>
            <div className="emoji">🔍</div>
            <p className="stage-note">
              {formatPenceShort(payload.roundupPence, payload.currency)} round-up detected
              <span className="progress-dots">…</span>
            </p>
          </>
        )}
        {stage === 1 && (
          <>
            <div className="emoji">📈</div>
            <p className="stage-note">
              Buying {payload.stockSymbol}
              <span className="progress-dots">…</span>
            </p>
          </>
        )}
        {stage === 2 && (
          <>
            <div className="emoji">🎉</div>
            <h3>You just invested in {payload.stockSymbol}!</h3>
            <div className="big-amount">{formatPence(payload.investedPence, payload.currency)}</div>
            <p className="detail">
              From {roundupLabel}
              {payload.costPence > 0 &&
                ` · ${formatPenceShort(payload.costPence, payload.currency)} execution cost`}
            </p>
            <button className="btn-primary" onClick={onDone}>
              Nice
            </button>
          </>
        )}
      </div>
    </div>
  );
}
